import { useNavigate, useLocation } from 'react-router'

const usePersistedNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const navigateWithPreservedParams = (path: string, options?: { replace?: boolean, state?: any }) => {
    // Get current URL parameters
    const currentParams = new URLSearchParams(location.search)
    // Split the new path into base path and query string
    const [basePath, newQueryString] = path.split('?')
    // Parse new query parameters if any
    const newParams = new URLSearchParams(newQueryString || '') 

    // Merge current parameters with new parameters
    currentParams.forEach((value, key) => {
      if (!newParams.has(key)) {
        newParams.set(key, value)
      }
    })

    // Construct the new path with merged parameters
    const newPath = `${basePath}?${newParams.toString()}`
    
    // Scroll to top before navigation
    window.scrollTo({ top: 0, behavior: 'smooth' })
    
    navigate(newPath, options)
  }

  return navigateWithPreservedParams
}

export default usePersistedNavigation
